import React, { useEffect, useState, useContext } from 'react'
import PhoneInput from "react-phone-input-2";
import { useProcessor } from '../../hooks/useProcessor';
import { useShareFiado } from '../../hooks/useShareFiado';
import FInput from '../../components/FInput/FInput';
import { useFormik } from "formik";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import FInputt from '../../components/FInputt/FInputt';
import { v4 as uuidv4 } from 'uuid';
import { useContacts } from '../../hooks/useContacts';
import { concat, map } from 'lodash';
import { usePhoneFormat } from '../../hooks/usePhoneFormat';
import FContainer from '../../components/FContainer/FContainer';
import FInputText from '../../components/Finputs/FInputText/FInputText';
import Fbutton from '../../components/Finputs/FButton/Fbutton';
import Swal from 'sweetalert2';
import FcardContact from '../../components/FcardContact/FcardContact';

export const ApplyForScreen = () => {
    const navigate = useNavigate();
    const { processPayment } = useProcessor();
    const [phone, setPhone] = useState('')
    const { setAlert } = useContext(AuthContext)
    const { isRegistered, setIsRegistered, identityInfo, setIdempotencyKey, setIdentityInfo, phoneNumber, setPhoneNumber, closeContact, idempotencyKey, getFirstDigits, getIdentify, getIdentity } = useShareFiado();
    const { getFavoriteContacts, favoriteContacts, getFirstLetter, aleatory3colors, getTwoWords } = useContacts();
    const { validateLocalPhone } = usePhoneFormat()
    //   useEffect(() => {
    //     getIdentifyByNumber(phoneNumber)
    // }, [phoneNumber]);

    const route = useNavigate()
    const identify = async (phoneNumber) => {
        const response = await getIdentify(phoneNumber);
        if (response === false) {
            const next = () => {
                formik.setFieldValue("number", "");
                setIsRegistered(false);
                setIdentityInfo([]);
            }

            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: 'Esta persona no se encuentra registrada en Fiado.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            }).then((result) => {
                if (result.isConfirmed) {
                    next();
                }
            })
        }
        setIdempotencyKey(uuidv4());
    }

    const nextScreen = async (data, idempotencyKey) => {

        let response = await processPayment(data, idempotencyKey);
        if (response?.data?.code == "PROCESS_OK") {

            const next = () => {
                route('/')
            }

            Swal.fire({
                showCloseButton: true,
                title: 'Éxito',
                text: 'Pediste dinero',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                // iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            }).then((result) => {
                if (result.isConfirmed) {
                    next();
                } else {
                    next();
                }
            })

            // setAlert('Éxito', 'Pediste el dinero', 'SUCCESS', true, next)

        }
        // let response = await processPayment(data, idempotencyKey);
        // if( response?.data?.code == "PROCESS_OK"){


        //     const next = ()=>{setIsRegistered(false);
        //         setIdentityInfo([]);
        //         setPhoneNumber('');
        //         navigate('/');
        //     }
        //     setAlert('Éxito','Pago realizado con éxito','SUCCESS',true,next)               
        // }
    }

    const formik = useFormik({
        initialValues: {
            amount: 0,
            concept: '',
            saveAsFavorite: false,
            number: ""
        },
        onSubmit: (values) => {
            const { amount, concept, saveAsFavorite } = values;
            const monto = parseInt(amount)
            const data = {
                originCurrencyId: "484",
                destinationCurrencyId: "484",
                exchangeRateId: null,
                products: [
                    {
                        id: "REQUEST_FIADO_SHARE_MXN",
                        amount: monto,
                        requestDirectoryId: identityInfo?.directoryId,
                        requestTypeOfDirectoryId: "USER",
                        concept: concept,
                    }

                ]
            }
            nextScreen(data, idempotencyKey);
        },
        validate: (values) => {

            const errors = {};

            if (values.amount == 0) {
                errors.amount = "El monto debe ser mayor a 0";
            }


            if (values.concept == '') {
                errors.concept = "Ingresa el concepto.";
            }


            if (validateLocalPhone(values.number) == false && validateLocalPhone(phoneNumber) == false) {
                errors.number = "Ingresa un número de teléfono válido.";
            }

            return errors;
        },
    })


    const getIdentifyByNumber = (phoneNumber) => {
        console.log(getFirstDigits(phoneNumber))
        if (getFirstDigits(phoneNumber) === '+1' && phoneNumber.length === 12) {
            console.log('usa')
            identify(phoneNumber);
        } else if ((getFirstDigits(phoneNumber) === '+52' || '+57') && phoneNumber.length === 13) {
            console.log('mexico')
            identify(phoneNumber);
        } else {

        }
    }


    const [aleatory3colorss, setaleatory3colorss] = useState('')

    useEffect(() => {
        console.log(formik?.values.number)
        getIdentifyByNumber(formik?.values.number);
    }, [formik?.values?.number])

    useEffect(() => {
        formik.setFieldValue(
            "number",
            ""
        );
        getFavoriteContacts();
        setaleatory3colorss(aleatory3colors())
    }, [])

    useEffect(() => {

        console.log(favoriteContacts)
        console.log(identityInfo)
    }, [[favoriteContacts]])



    return (
        <>
            <FContainer>
                {
                    isRegistered ? (<>
                        <FcardContact
                            className="!shadow-none !my-2"
                            backgroundInitial={aleatory3colorss}
                            preferredName={identityInfo.name}
                            onDeleteMembers={() => {
                                formik.setFieldValue(
                                    "number",
                                    ""
                                );
                                closeContact()
                            }}
                        />
                    </>)
                        : null


                }




                {isRegistered ? null : isRegistered ? (<>
                    <FInputText type="PhoneInput" title="¿A quién le vas a pedir?" disabled={isRegistered}
                        value={formik.values.number} onChange={(value) => {
                            formik.setFieldValue("number", value);
                        }}
                        errorMessage={formik.values.number == "" ? "" : formik.errors.number}
                    />
                </>)
                    : <FInputText type="PhoneInput" title="¿A quién le vas a pedir?" disabled={isRegistered}
                        value={formik.values.number} onChange={(value) => {
                            formik.setFieldValue("number", value);
                        }}
                        errorMessage={formik.values.number == "" ? "" : formik.errors.number}

                    />}








                <FInputText
                    type="CurrencyInput"
                    title={"Cantidad a solicitar (MXN)"}
                    laceholder="¿Cuánto?"
                    value={formik.values.amount}
                    maxLength={10}
                    onChange={async (value) => {
                        formik.setFieldValue("amount", value == undefined ? 0 : value);

                    }}
                    errorMessage={
                        formik.errors.amount
                    }
                />
                <FInputText title={"Concepto"} placeholder={"Concepto"} value={formik.values.concept} onChange={(value) => {
                    formik.setFieldValue(
                        "concept",
                        value
                    );
                }} />

{favoriteContacts?.length > 0 ? (
                <div className='mt-5 flex content-center  items-center  bg-stripes-sky text-center h-28 p-1 justify-start  overflow-y-hidden overflow-x-scroll' >

                    {
                        favoriteContacts?.length > 0 ?
                            favoriteContacts.map((contact, index) => (
                                <div className='p-2 grid place-items-center' onClick={() => {
                                    formik.setFieldValue(
                                        "number",
                                        contact.phoneNumber
                                    );
                                    getIdentity(contact.phoneNumber)
                                }}>
                                    <div>
                                        <div style={{ backgroundColor: aleatory3colorss }} className={`shadow-lg rounded-[12px] h-[60px] w-[60px] font-bold flex flex-col justify-center cursor-pointer`}>
                                            <div className='text-white text-xl'>{getFirstLetter(contact.preferedName)}</div>
                                        </div>
                                    </div>
                                    <div>{getTwoWords(contact.preferedName)}</div>
                                </div>

                            )) : null
                    }

</div>) : null}


                <Fbutton
                    value={"Continuar"}
                    disabled={!formik.isValid}
                    onClick={formik.handleSubmit}
                />
                <div className='pt-5 text-Secondary font-bold text-[16px] cursor-pointer' onClick={() => {
                    route("/ApplyGroupScreen")
                }}>
                    ¿Deseas solicitar a varias personas al tiempo?
                </div>
            </FContainer>
        </>
    )
}
